module.exports = __webpack_public_path__ + "img/no-feed-data.11a88441.svg";